// Small pure helpers shared across the app.

// cn lives in @soma/ui so the package and the app cannot drift apart on it.
export { cn } from "@soma/ui";

/** 128400 → "128,400". Fixed locale so server and client render the same string. */
export function fmtTokens(n: number): string {
  return Math.round(n).toLocaleString("en-US");
}

/** Share saved against a baseline index: (100, 85) → 15. null when not measured. */
export function savedPct(before: number, after: number | null): number | null {
  if (after === null || before <= 0) return null;
  return Math.round((1 - after / before) * 100);
}

/** 0.9553 → "$0.96": list prices per 1M tokens, two decimals like the app's model table. */
export function fmtUsd(value: number): string {
  return `$${value.toFixed(2)}`;
}

/** 15 → "−15%" (typographic minus, matches the rest of the page). */
export function fmtSavedPct(pct: number): string {
  return `−${pct}%`;
}

/** 0 → "01": step numbers in a real sequence. */
export function fmtStep(index: number): string {
  return String(index + 1).padStart(2, "0");
}

export function clamp(v: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, v));
}

/** Hermite smoothstep on 0..1. */
export function smoothstep(x: number): number {
  const t = clamp(x, 0, 1);
  return t * t * (3 - 2 * t);
}

/** "https://app.thesoma.ai/v1" -> "app.thesoma.ai". Falls back to the input if unparseable. */
export function hostOf(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}
